module.exports = __webpack_public_path__ + "static/pic02.3c6537b4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/pic02.jpg
// module id = 352
// module chunks = 114276838955818